import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Field } from 'redux-form'
import classnames from 'classnames'
import VirtualizedSelect from 'react-virtualized-select'
import Select from 'react-select'
import { FormattedMessage } from 'react-intl'
import Svg from 'components/util/Svg'
import fieldProps from '../fieldProps'
import FieldLabel from '../FieldLabel'
import FieldError from '../FieldError'
import './react-select.global.css'
import './react-virtualized.global.css'
import './react-virtualized-select.global.css'
import styles from './_singleSelectField.css'

export class SingleSelectField extends Component {

  static propTypes = fieldProps;

  static defaultProps = {
    placeholder: (
      <FormattedMessage
        id='forms.single_select_field.default_placeholder'
        defaultMessage='Select&hellip;'
      />
    ),
  };

  handleChange = (args) => {
    const newValue = args ? args.value : null
    this.props.input.onChange(newValue)
    if (this.props.onChange) { this.props.onChange(newValue) }
  }

  renderArrow = () => {
    return <Svg name='select_down' className={styles.arrow} />
  }

  getSelectComponent = () => {
    const { virtualized, async } = this.props
    if (virtualized) { return VirtualizedSelect }
    if (async) { return Select.Async }
    return Select
  }

  render () {
    const {
      input,
      name,
      disabled,
      required,
      slim,
      labelComponent,
      errorComponent,
      placeholder,
      options,
      bold,
      virtualized,
      meta: {
        error,
        touched,
      },
    } = this.props

    const showError = touched && !!error
    const className = classnames(styles.container, {
      [styles.disabled]: disabled,
      [styles.slim]: slim,
      [styles.showError]: showError,
      [styles.inputError]: showError,
    })
    const SelectComponent = virtualized ? VirtualizedSelect : Select

    return (
      <label htmlFor={name} className={className}>
        <FieldLabel
          labelComponent={labelComponent}
          required={required}
          bold={bold}
        />

        <SelectComponent
          {...this.props}
          required={false}
          name={name}
          options={options}
          onChange={this.handleChange}
          value={input.value}
          arrowRenderer={this.renderArrow}
          placeholder={placeholder}
        />

        <FieldError
          errorComponent={errorComponent}
          showError={showError}
          errorMessage={error}
        />
      </label>
    )
  }

}

export const renderField = (field) => (
  <SingleSelectField {...field} />
)

export const FieldWrapper = (props) => (
  <Field {...props} component={renderField} />
)

FieldWrapper.propTypes = {
  virtualized: PropTypes.bool,
}

export default FieldWrapper



// WEBPACK FOOTER //
// ./src/components/forms/SingleSelectField/SingleSelectField.jsx